import { RootState } from "../../index";

// get All Subscription Plan
export const getStoredWebhook = (state: RootState) => state.webhook.getWebhook;

export const postWebhook = (state: RootState) => state.webhook.webhook;
